"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let MetricRankTag = class MetricRankTag extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.colorController = new ColorLibController_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get polishedClass() {
        if (this.dimension !== 'phch')
            return `${this.fixedScale}${this.rankShortName}`;
        return '';
    }
    get polishedValue() {
        if (this.hasValue)
            return this.score;
        return '';
    }
    get polishedLabel() {
        if (this.label.length > 0)
            return this.label;
        if (this.scale.includes('need'))
            return (0, trans_1.trans)('becrop_report.need_level.' + this.fixedRank);
        if (this.hasValue) {
            return this.unit;
        }
        else {
            return (0, trans_1.trans)('becrop_report.rank_level.' + this.fixedRank);
        }
    }
    get hasValue() {
        if (this.scale.includes('need'))
            return false;
        if (this.unit.toUpperCase() === 'BSC') {
            if (this.score > 0) {
                return true;
            }
            else
                return false;
        }
        else {
            // return true
            return this.score > 0;
        }
        return false;
    }
    get fixedScale() {
        if (this.scale === 'std')
            return '';
        if (this.scale === 'hlt')
            return 'alt_';
        if (this.scale.includes('need'))
            return 'alt_';
        return '';
    }
    get fixedRank() {
        return this.ranksEnabled
            ? (this.scale === 'need'
                ? this.colorController.getRankFromNeedScore(this.score)
                : (this.scale === 'need-rank' ? this.score : this.colorController.getRankFromScore(this.score)))
            : 0;
    }
    get rankShortName() {
        return this.ranksEnabled
            ? (this.scale === 'need'
                ? this.colorController.getRankShortNameFromNeedScore(this.score)
                : (this.scale === 'need-rank' ? this.colorController.getRankShortNameFromNumber(this.score) : this.colorController.getRankShortNameFromScore(this.score)))
            : '';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], MetricRankTag.prototype, "score", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MetricRankTag.prototype, "scale", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'vertical' })
], MetricRankTag.prototype, "orientation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'm' })
], MetricRankTag.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], MetricRankTag.prototype, "ranksEnabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MetricRankTag.prototype, "unit", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MetricRankTag.prototype, "label", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MetricRankTag.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true })
], MetricRankTag.prototype, "available", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MetricRankTag.prototype, "dimension", void 0);
MetricRankTag = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {},
    })
], MetricRankTag);
exports.default = MetricRankTag;
